import React from 'react'
import Header from '../header'
import Footer from '../footer'
import styles from '../../styles/Text.module.css'
import Head from 'next/head'
import { useTranslation } from 'next-i18next'
import { GetStaticProps, InferGetStaticPropsType, } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'

const DeliveryReturnTerms = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const baseUrl = 'https://stoneity.com';
  const currentPath = router.asPath;
  const locale = router.locale || 'en';
  const canonicalUrl = locale === 'tr'
    ? `${baseUrl}/tr${currentPath}`
    : `${baseUrl}${currentPath}`;
  const alternateLocale = locale === 'tr' ? 'en' : 'tr';
  const alternatePath = '/delivery-refund-terms';

  return (
    <>
      <Head>
        <title>{t("seo_delivery_refund_terms_title")}</title>
        <meta name="description" content={t("seo_delivery_refund_terms_description")} />
        <meta name="keywords" content={locale === 'tr'
          ? "teslimat şartları, iade şartları, Stoneity, delivery refund terms"
          : "delivery terms, refund terms, Stoneity, delivery refund terms"} />
        <link key="canonical" rel="canonical" href={canonicalUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={t("seo_delivery_refund_terms_title")} />
        <meta property="og:description" content={t("seo_delivery_refund_terms_description")} />
        <meta property="og:image" content={`${baseUrl}/stoneityLogo.png`} />
        <meta property="og:site_name" content="Stoneity" />
        <meta property="og:locale" content={locale === 'tr' ? 'tr_TR' : 'en_US'} />
        <meta property="og:locale:alternate" content={locale === 'tr' ? 'en_US' : 'tr_TR'} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={canonicalUrl} />
        <meta name="twitter:title" content={t("seo_delivery_refund_terms_title")} />
        <meta name="twitter:description" content={t("seo_delivery_refund_terms_description")} />
        <meta name="twitter:image" content={`${baseUrl}/stoneityLogo.png`} />
        <meta name="twitter:site" content="@stoneity" />

        {/* Alternate languages */}
        <link rel="alternate" hrefLang={locale} href={canonicalUrl} />
        <link rel="alternate" hrefLang={alternateLocale} href={`${baseUrl}/${alternateLocale}${alternatePath}`} />
        <link rel="alternate" hrefLang="x-default" href={`${baseUrl}${alternatePath}`} />
      </Head>
      <Header />
      <main style={{ paddingInline: '1rem' }}>
        <div className={styles.globalTextContent}>
          <div>
            <div className={styles.globalTitle}>
              {t("deliveryAndReturnTerms")}
            </div>
            <p className={styles.globalExplainParagraph}>
              {t("deliveryAndReturnTermsIntro")}
            </p>
          </div>
          <div>
            <div className={styles.globalSideTitle}>{t("digitalDeliveryTitle")}</div>
            <div className={styles.globalExplainParagraph}>
              {t("digitalDeliveryExplain")}
            </div>
          </div>
          <div>
            <div className={styles.globalSideTitle}> {t("deliveryTitle")}</div>
            <div className={styles.globalExplainParagraph}>
              {t("deliveryExplain")}
            </div>
          </div>
          <div>
            <div className={styles.globalSideTitle}> {t("activationOfServiceTitle")}</div>
            <div>
              <div className={styles.globalExplainParagraph}>
                {t("activationOfServiceExplain1")}
              </div>
              <div className={styles.globalExplainParagraph} style={{ marginTop: "0" }}>
                {t("activationOfServiceExplain2")}
              </div>
            </div>
          </div>
          <div>
            <div className={styles.globalSideTitle}> {t("refundConditionsTitle")}</div>
            <div>
              <div className={styles.globalExplainParagraph}>
                {t("refundConditionsExplain1")}
              </div>
              <div className={styles.globalExplainParagraph} style={{ marginTop: "0" }}>
                {t("refundConditionsExplain2")}
              </div>
            </div>
          </div>
          <div>
            <div className={styles.globalSideTitle}> {t("technicalIssueTitle")}</div>
            <div className={styles.globalExplainParagraph}>
              {t("technicalIssueExplain")}
            </div>
          </div>
          <div>
            <div className={styles.globalSideTitle}> {t("serviceModificationTitle")}</div>
            <div className={styles.globalExplainParagraph}>
              {t("serviceModificationExplain")}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || "en", ["common"])),
  },
});

export default DeliveryReturnTerms;
